import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The landing logo is inline SVG rather than `fr8bot-ui-icon`: the icon fetches its sprite over
 * HTTP after the page boots, so the prerendered logo flashed blank until the request came back.
 */
@Component({
  selector: 'fr8bot-web-logo',
  templateUrl: './web-logo.html',
  host: { class: 'tw:block tw:h-6 tw:w-[210px]' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebLogo {}
